import { render, staticRenderFns } from "./ValoracionesResumen.vue?vue&type=template&id=7f0b3509"
import script from "./ValoracionesResumen.vue?vue&type=script&lang=js"
export * from "./ValoracionesResumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports